/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for Party controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { PartyType, RequestOptions, GetPartiesResponse } from "../models";

@Injectable({ providedIn: "root" })
export class PartyService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    getParties(types?: (Array<PartyType> | null), observe?: 'body', options?: RequestOptions<'json'>): Observable<GetPartiesResponse>;
    getParties(types?: (Array<PartyType> | null), observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetPartiesResponse>>;
    getParties(types?: (Array<PartyType> | null), observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetPartiesResponse>>;
    getParties(types?: (Array<PartyType> | null), observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Party`;

        let params = new HttpParams();
        if (types != null) {
            params = HttpParamsBuilder.addToHttpParams(params, types, 'types');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }
}
